const data = {
  state: {
      skip: 0,
      take: 10,
      filter: {
          logic: 'and' as 'and',
          filters: []
      },
      group: []
  },
  columnsConfig: [
    {
        field: 'reference',
        title: 'Référence'
      },
      {
        field: 'beginofsession',
        title: 'Début'
      },
      {
        field: 'endofsession',
        title: 'Fin'
      },
      {
        field: 'location',
        title: 'Ville'
      },
      {
        field: 'modalite',
        title: 'Modalité'
      },
      {
        field: 'libelle',
        title: 'Formation'
      },
      {
        field: 'statutsession',
        title: 'Status'
      }
  ]
};

export default data;